import { createContext } from "react";
export var CollapseContext = createContext({
    activeIds: [],
    onActive: function () { return null; },
});
//# sourceMappingURL=CollapseContext.js.map